// extracted by mini-css-extract-plugin
export default {"ExternalImage":"ExternalImage__ExternalImage___J04Tb"};